import { createSlice } from "@reduxjs/toolkit";
import { getAdById, getSingleAdAnalytics } from "./thunk";

export const initialState = {
    singleAd: null, // to store data from getAdById
    analyticsData: null, // to store data from getSingleAdAnalytics
    error: "", // for error message
    loading: false,
};

const adAnalyticsSlice = createSlice({
    name: "adAnalytics",
    initialState,
    reducers: {
        resetSingleAd: (state) => {
            state.singleAd = null; // reset singleAd to null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdById.fulfilled, (state, action) => {
                state.singleAd = action.payload;
                state.loading = false;
            })
            .addCase(getAdById.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            })
            .addCase(getSingleAdAnalytics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSingleAdAnalytics.fulfilled, (state, action) => {
                state.analyticsData = action.payload;
                state.loading = false;
            })
            .addCase(getSingleAdAnalytics.rejected, (state, action) => {
                state.error = action?.payload?.error || null;
                state.loading = false;
            });
    },
});
export const { resetSingleAd } = adAnalyticsSlice.actions;
export default adAnalyticsSlice.reducer;
